const state = () => ({
    // state
});

const getters = {
    // getters
};

const mutations = {
    // mutations
};

const actions = {
    // actions
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
};
